
/* eslint-disable object-curly-newline */
import { Message } from '../models';

export const composeClassName = (
    author: string | undefined,
    isFirstInGroup: boolean,
    isLastInGroup: boolean | undefined | 0,
    nextMessage?: Message
): string => 'chat-message'
+ ` author-${author}`
+ `${isFirstInGroup ? ' is-first' : ''}`
+ `${isLastInGroup ? ' is-last' : ''}`
+ `${nextMessage && nextMessage.type ? ` next-message-type-${nextMessage.type}` : ''}`;
